import { FC } from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Done from '@mui/icons-material/Done';


type Props = {
  length: number
  minLength?: number
  message?: string
}

export const LengthEstimates: FC<Props> = ({
  length,
  minLength = 150,
  message = 'Aim for 25 - 167 words for best results',
}) => {
  if (length < minLength) {
    return (
      <Typography variant="caption" color="text.secondary" fontWeight={500}>
        {message}
      </Typography>
    );
  }

  return (
    <Stack component="span" direction="row" alignItems="center" gap={0.5}>
      <Typography variant="caption" color="success" fontWeight={500}>
        Great length!
      </Typography>
      <Done color="success" fontSize="inherit"/>
    </Stack>
  );
};
